import { reduceMessages } from './reduceMessages';
import { reduceTurn } from './reduceTurn';
import { reduceTools } from './reduceTools';
import { reduceQueue } from './reduceQueue';
import { reduceHistory } from './reduceHistory';
function composeReducers(...reducers) {
  return (state, action) => reducers.reduce((s, reducer) => reducer(s, action), state);
}
export const chatReducer = composeReducers(reduceMessages, reduceTurn, reduceTools, reduceQueue, reduceHistory);